
//Format number
export function formatNumber(number, options) {

  //Sanitize input
  if (!number || number === Infinity || number === -Infinity || isNaN(number)) {
    number = 0
  }

  //Default config
  const defaults = {
    useGrouping: true,
    maximumFractionDigits: 2,
  }

  //Merge options and create formatter
  options = Object.assign({}, defaults, options)
  const formatter = new Intl.NumberFormat('en-US', options)

  //Use number filter
  return formatter.format(number)
}

//Format percentage
export function formatPercentage(fraction, options, emptyLabel = '') {

  //Empty input
  if (fraction === null || fraction === undefined || isNaN(fraction)) {
    return emptyLabel
  }

  //Sanitize input
  if (fraction === Infinity || fraction === -Infinity) {
    fraction = 0
  }

  //Default config
  const defaults = {
    useGrouping: true,
    maximumFractionDigits: 0,
  }

  //Merge options and create formatter
  options = Object.assign({}, defaults, options)
  const formatter = new Intl.NumberFormat('en-US', options)

  //Use number filter
  return formatter.format(fraction * 100) + '%'
}
